module.exports = {
  convertTransactionMessage: function (message) {
    if (message) {
      if (message.includes('failed')) {
        return message.replace(new RegExp('failed'), 'DECLINED')
      }
      if (message.includes('completed')) {
        return message.replace(new RegExp('completed'), 'APPROVED')
      }
    }
    return message
  },
}
